import React, { useState, useEffect } from 'react';
import imageModifier from '../../../../../utils/imageModifier';

import UIChooseImageModal from './UIChooseImageModal';

const POSTAL_IMAGE_PREVIEW_SIZE = '1440x755'

const UIImage = ({
  label=false,
  imageUrl = { 'en': '' },
  description = { 'en': '' },
  activeLanguage = 'en',
  setImageUrl = () => { },
  setDescription = () => { },
  getImageUrl = () => {}, // NOTE: just get the url instead of the entire imageUrl obj
  isFromPostal = false,
}) => {

  const [showModal, setShowModal] = useState(false);
  const [size, setSize] = useState('1200x750');
  const [isPublic, setIsPublic] = useState(false);

  const toggleSize = () => setSize(`${size === '1200x1200' ? '1200x750' : '1200x1200'}`);
  const toggleModal = () => setShowModal(!showModal)

  const willSetImageFromMAM = ([obj]) => {
    toggleModal();
    imageUrl[activeLanguage] = obj.url
    setImageUrl(imageUrl);
    setIsPublic(obj.isPublic);
    getImageUrl(obj.url);
    setTimeout(() => {
      setDescription(obj.description || { en: '' })
    }, 500);
  };

  useEffect(() => {
    if (isFromPostal) setSize(POSTAL_IMAGE_PREVIEW_SIZE);
  });

  return (
    <>
      <div className="flex justify-start flex-col text-black">
        {label && <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold -mb-3 mt-2">{label}</label>}
        <div className="bg-grey-lighter flex items-center justify-center min-h-50 my-6 w-full relative">
          <img src={imageModifier(imageUrl?.[activeLanguage], size)} alt={description.en} style={{ maxWidth: 900 }} className="rounded w-full" />
          <div className="absolute bottom-0 left-0 m-4 flex flex-wrap">
            <div onClick={toggleModal} className="hover:bg-white bg-white-dark flex h-10 items-center justify-center opacity-85 hover:opacity-100 px-4 rounded">
              <div className="block uppercase tracking-wide text-gray-700 text-xs font-bold">{`${imageUrl?.[activeLanguage] ? 'Change image' : 'Select image'}`}</div>
            </div>
          </div>
          {
            !isFromPostal && (
              <div className="absolute bottom-0 right-0 m-4 flex flex-wrap">
                <div onClick={toggleSize} className="hover:bg-white bg-white-dark opacity-85 hover:opacity-100 flex h-10 items-center justify-center mr-1 rounded w-10 ">
                  <div style={{ width: 16, height: 16 }} className={`border-2 ${size === '1200x1200' ? 'border-black' : ''}`} />
                </div>
                <div onClick={toggleSize} className="hover:bg-white bg-white-dark opacity-85 hover:opacity-100 flex h-10 items-center justify-center mr-1 rounded w-10">
                  <div style={{ width: 25, height: 16 }} className={`border-2 ${size === '1200x1200' ? '' : 'border-black'}`} />
                </div>
              </div>
            )
          }
          {!isPublic && (
            <div className="absolute top-0 right-0 m-4 flex flex-wrap">
              <div className="bg-white-dark opacity-85 flex h-10 items-center justify-center mr-1 rounded w-10 ">
                <span className="font-icon icon-lock" />
              </div>
            </div>
          )}
        </div>
      </div>
      {showModal && <UIChooseImageModal toggleModal={toggleModal} setImage={willSetImageFromMAM} />}
    </>
  );
};

export default UIImage;
